import { render, staticRenderFns } from "./PricePopover2.vue?vue&type=template&id=89074a4c&scoped=true"
import script from "./PricePopover2.vue?vue&type=script&lang=js"
export * from "./PricePopover2.vue?vue&type=script&lang=js"
import style0 from "./PricePopover2.vue?vue&type=style&index=0&id=89074a4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89074a4c",
  null
  
)

export default component.exports